module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_privacy.65bdb6b397e72fba263c2d631962eca6.png";